const enJSON = {
	SimplyBorrowed: 'SimplyBorrowed',
	'Customer Portal': 'Customer Portal',
	'Apply for a loan': 'Apply for a loan',
	'Please complete your profile before applying for a loan.':
		'Please complete your profile before applying for a loan.',
	'Complete my profile': 'Complete my profile',
	'Your legal status document has been rejected.': 'Your legal status document has been rejected.',
	'Update my legal status document.': 'Update my legal status document.',
	'Loans Information': 'Loans Information',
	'Details about loans that you have requested.': 'Details about loans that you have requested.',
	Number: 'Number',
	Amount: 'Amount',
	Status: 'Status',
	Action: 'Action',
	Close: 'Close',
	Cancel: 'Cancel',
	Confirm: 'Confirm',
	'Pending Loan Requests': 'Pending Loan Requests',
	"You have a loan request that has not finish it's verification process":
		"You have a loan request that has not finish it's verification process.",
	'Ask for a new one': 'Ask for a new one',
	'NOTE: You can only have one active loan or request on your profile. If you need to cancel a requested loan you could write us at info@simplyborrowed.ca.':
		'NOTE: You can only have one active loan or request on your profile. If you need to cancel a requested loan you could write us at info@simplyborrowed.ca.',
	Dashboard: 'Dashboard',
	Payments: 'Payments',
	Users: 'Users',
	Marketing: 'Marketing',
	Settings: 'Settings',
	Help: 'Help',
	Profile: 'Profile',
	Logout: 'Logout',
	Home: 'Home',
	LOAN: 'LOAN',
	'Server is not responding': 'Server is not responding.',
	'You cannot refinance this loan until your next payment is completed':
		'You cannot refinance this loan until your next payment is completed',
	"You can't pay the full balance while having due instalments":
		"You can't pay the full balance while having due instalments",
	"You can't pay the full balance when your next payment is due within the next 5 business days.":
		"You can't pay the full balance when your next payment is due within the next 5 business days.",
	"You will be able to pay your loan's full balance, once your loan has been funded.":
		"You will be able to pay your loan's full balance, once your loan has been funded.",
	"You will be able to refinance after you have paid all your due instalments'":
		'You will be able to refinance after you have paid all your due instalments',
	'You will be able to refinance your loan after 60 days from your last payment':
		'You will be able to refinance your loan after 60 days from your last payment',
	'Go back to all Loans': 'Go back to all Loans',
	'This loan has been suspended. Please contact us for more information at info@simplyborrowed.ca':
		'This loan has been suspended. Please contact us for more information at info@simplyborrowed.ca',
	'This loan has some documents requested. Please scroll down and upload them as soon as possible.':
		'This loan has some documents requested. Please scroll down and upload them as soon as possible.',
	'General conditions': 'General Conditions',
	'Bank Information': 'Bank Information',
	'Change bank information': 'Change bank information',
	"You've already requested a Bank Change": "You've already requested a Bank Change",
	'Your last bank change request was cancelled, you could request a new one':
		'Your last bank change request was cancelled, you could request a new one',
	'Instalments Payed': 'Instalments Payed',
	'Your current Balance is:': 'Your current Balance is:',
	'You have already requested a FULL PAYMENT of your Loan. You will be notified by email once the transaction is completed.':
		'You have already requested a FULL PAYMENT of your Loan. You will be\n\t\tnotified by email once the transaction is completed.',

	'Pay full balance': 'Pay full balance',
	'Refinance loan': 'Refinance loan',
	'Interest rate': 'Interest Rate',
	'Admin fees': 'Admin fees',
	'Payment Schedule': 'Payment Schedule',
	'No payment has been registered for this loan.': 'No payment has been registered for this loan',
	'Your Next Payment is Due on': 'Your Next Payment is Due on',
	'Contract Information': 'Contract Information',
	'Additional Documents': 'Additional Documents',
	'Account Number is required': 'Account Number is required',
	'Account Number should be 12 digits max': 'Account Number should be 12 digits max',
	'Transit Number is required': 'Transit Number is required',
	'Transit Number should be a 5 digit number': 'Transit Number should be a 5 digit number',
	'Fi Number is required': 'Fi Number is required',
	'Transit Number should be a 3 digit number': 'Transit Number should be a 3 digit number',
	'Account Number is already registered': 'Account Number is already registered',
	'Routing Number is already registered': 'Routing Number is already registered',
	'Requesting Bank Change, please wait': 'Requesting Bank Change, please wait',
	'Something went wrong when trying to change your bank, please tray again':
		'Something went wrong when trying to change your bank, please tray again',
	Deferred: 'Deferred',
	'Loan balance': 'Loan balance',
	'Deferred from': 'Deferred from',
	'Deferred charge': 'Deferred charge',
	'Moved to': 'Moved to',
	'Deferred Payments': 'Deferred Payments',
	IMPORTANT: 'IMPORTANT',
	'You currently have instalments that were deferred by the SimplyBorrowed Team and that need to be paid before paying or refinancing the full balance of your Loan.':
		'You currently have instalments that were deferred by the SimplyBorrowed Team and that need to be paid before paying or refinancing the full balance of your Loan.',
	'Number of Deferred Payments': 'Number of Deferred Payments',
	'Total amount of Deferred Payments': 'Total amount of Deferred Payments',
	'Please, click the button to generate a payment request that will be sent to your email.':
		'Please, click the button to generate a payment request that will be sent to your email.',
	'Pay deferred payments': 'Pay deferred payments',
	'Please confirm the action by writing the correct phrase': 'Please confirm the action by writing the correct phrase',
	'This action cannot be undone. Once you click confirm, you authorize SimplyBorrowed to debit the following bank account, the specified amount.':
		'This action cannot be undone. Once you click confirm, you authorize SimplyBorrowed to debit the following bank account, the specified amount.',
	'Bank name': 'Bank name',
	'Transit Number': 'Transit Number',
	'FI Number': 'FI Number',
	'Please write pay full balance in the box, before confirming':
		'Please write pay full balance in the box, before confirming.',
	'There was a problem uploading the documents, please try again':
		'There was a problem uploading the documents, please try again',
	'Documents uploaded successfully': 'Documents uploaded successfully',
	'Uploading documents, please wait': 'Uploading documents, please wait...',
	Actions: 'Actions',
	Description: 'Description',
	'Updated At': 'Updated At',
	'Upload documents': 'Upload documents',
	'View Rejection Reason': 'View Rejection Reason',
	'Submit again': 'Submit again',
	'Rejection Reason': 'Rejection Reason',
	'Payment Number': 'Payment Number',
	'Date Due': 'Date Due',
	Payment: 'Payment',
	Balance: 'Balance',
	'Document was resend to those who have not signed the document yet, through DocuSign reminder.':
		'Document was resend to those who have not signed the document yet, through DocuSign reminder',
	'Something wrong happened when trying to resend the documents, please try again':
		'Something wrong happened when trying to resend the documents, please tru again',
	'The Documentation process has not started yet': 'The Documentation process has not started yet',
	'Documentation process has completed': 'Documentation process has completed',
	'Documentation was created but has not finished the signing process':
		'Documentation was created but has not finished the signing process',
	'Here are some details of the signing process': 'Here are some details of the signing process',
	Order: 'Order',
	Name: 'Name',
	'Delivered at': 'Delivered at',
	'Signed at': 'Signed at',
	'Not delivered': 'Not Delivered',
	Signed: 'Signed',
	'Not signed': 'Not Signed',
	'Open docusign envelope': 'Open docusign envelope',
	'Resend Document to Pending Signers': 'Resend Document to Pending Signers',
	'Something happened when tried to fetch the document information, please refresh the page':
		'Something happened when tried to fetch the document information, please refresh the page',
	'There was a problem uploading the void cheque image': 'There was a problem uploading the void cheque image',
	'There was a problem uploading the picture, please try again':
		'There was a problem uploading the picture, please try again',
	'Select your Bank': 'Select your Bank',
	'Upload Void Cheque Image': 'Upload Void Cheque Image',
	'This Client is not eligible for Bonus Points.': 'This Client is not eligible for Bonus Points.',
};

export default enJSON;
